var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.337 0H1.663A1.675 1.675 0 0 0 0 1.663v26.674A1.675 1.675 0 0 0 1.663 30h14.362V18.4h-3.9v-4.537h3.9v-3.338c0-3.875 2.363-5.988 5.838-5.988 1.162 0 2.325 0 3.487.176V8.75h-2.388c-1.887 0-2.25.9-2.25 2.213v2.887h4.5l-.587 4.537h-3.913V30h7.625A1.675 1.675 0 0 0 30 28.337V1.663A1.675 1.675 0 0 0 28.337 0Z",
    fill: "var(--default-text-color)"
  })));
};

export default SvgFacebook;